var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "5888DB70-F8B3-4FB8-B86A-4E6BA3B1D8D4@2.00x"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M645.5 203.711a.738.738 0 0 1-.412-.124c-.496-.328-12.088-8.137-12.088-15.25 0-3.655 3.068-6.626 6.836-6.626 3.006 0 4.354 1.645 5.664 3.878 1.043-2.142 2.46-3.878 5.661-3.878 3.772 0 6.839 2.972 6.839 6.627 0 7.112-11.595 14.921-12.088 15.249a.738.738 0 0 1-.412.124z", id: "path-1-heart-ProductPackageScreen" }),
      React.createElement(
        "filter",
        { x: "-28%", y: "-22.7%", width: "156%", height: "163.6%", filterUnits: "objectBoundingBox", id: "filter-2-heart-ProductPackageScreen" },
        React.createElement("feOffset", { dy: "2", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0", "in": "shadowBlurOuter1" })
      )
    ),
    React.createElement(
      "g",
      { transform: "rotate(-25 -68.198 1522.829)", fillRule: "nonzero", fill: "none" },
      React.createElement("use", { fill: "#000", filter: "url(#filter-2-heart-ProductPackageScreen)", xlinkHref: "#path-1-heart-ProductPackageScreen" }),
      React.createElement("use", { fill: "#FFBFF4", xlinkHref: "#path-1-heart-ProductPackageScreen" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/apps/boosts/components/svgs/heart.svg